/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does word reversal treat spacing?`)
};

const es_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo trata la inversión de palabras el espaciado?`)
};

const de_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie behandelt die Wortumkehrung Leerzeichen?`)
};

const nl_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe gaat woordomkering om met spatiëring?`)
};

const fr_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le mode Mots traite-t-il l'espacement ?`)
};

const it_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come gestisce l'inversione delle parole la spaziatura?`)
};

const pt_br2_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a inversão de palavras trata o espaçamento?`)
};

const pt_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a inversão de palavras trata o espaçamento?`)
};

const ja_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語反転はスペースをどのように処理しますか?`)
};

const zh_rv_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词反转如何处理空格？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq2_q", locale)
	if (locale === "en") return en_rv_faq2_q(inputs)
	if (locale === "es") return es_rv_faq2_q(inputs)
	if (locale === "de") return de_rv_faq2_q(inputs)
	if (locale === "nl") return nl_rv_faq2_q(inputs)
	if (locale === "fr") return fr_rv_faq2_q(inputs)
	if (locale === "it") return it_rv_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq2_q(inputs)
	if (locale === "pt") return pt_rv_faq2_q(inputs)
	if (locale === "ja") return ja_rv_faq2_q(inputs)
	return zh_rv_faq2_q(inputs)
};